'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export default function AddonsSection() {
  const { t } = useLanguage();

  return (
    <section
      id="serveis-complementaris"
      className="py-24 px-6 bg-[#07070b] relative overflow-hidden border-t border-white/5"
      aria-label="Serveis complementaris i ampliacions"
    >
      <div className="max-w-7xl mx-auto space-y-16 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold text-[11px] font-bold uppercase tracking-widest">
            {t.addons.badge}
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight uppercase">
            {t.addons.title}
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            {t.addons.sub}
          </p>
        </div>

        {/* Modular Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {t.addons.items.map((addon, index) => (
            <div
              key={index}
              className="rounded-2xl p-7 bg-gradient-to-b from-[#111119] to-[#09090e] border border-white/10 hover:border-gold/30 transition-all duration-300 flex flex-col justify-between space-y-5"
            >
              <div className="space-y-3">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-lg font-bold text-white">
                    {addon.title}
                  </h3>
                  <span className="text-xs font-black text-gold bg-gold/10 px-2.5 py-1 rounded-md border border-gold/20 whitespace-nowrap">
                    {addon.price}
                  </span>
                </div>

                <p className="text-xs text-slate-300 leading-relaxed">
                  {addon.desc}
                </p>

                <ul className="space-y-2 pt-2 border-t border-white/5">
                  {addon.points.map((pt, pIdx) => (
                    <li key={pIdx} className="flex items-start gap-2 text-xs text-slate-400">
                      <span className="text-gold font-bold">›</span>
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pt-2">
                <a
                  href={`https://wa.me/34694919757?text=Hola%2C%20m%27interessa%20afegir%20el%20servei%20de%20${encodeURIComponent(addon.title)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center py-2.5 px-3 rounded-lg bg-white/5 hover:bg-white/10 text-xs font-bold text-slate-200 hover:text-gold border border-white/10 transition-colors"
                >
                  {t.addons.infoButton}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
